import { gql } from '@apollo/client';
import appraiserEventFieldsFragment from './appraiserEventFragment';
import userEventParticipationInfoCalendarViewFragment from './userEventParticipationInfoCalendarViewFragment';

const GET_ADMIN_CALENDAR = gql`
  query GetAdminCalendar($start: DateOnly!, $end: DateOnly!) {
    adminAppraiserEvents(start: $start, end: $end) {
      ...AppraiserEventFields
      TargetUserEventParticipationInfo(targetUserId: null) {
        ...UserEventParticipationInfoFields
      }
    }
    availableAppraisers(start: $start, end: $end) {
      Atls {
        ...AppraiserInfoFields
      }
      AtlCandidates {
        ...AppraiserInfoFields
      }
      Atms {
        ...AppraiserInfoFields
      }
      AtmCandidates {
        ...AppraiserInfoFields
      }
    }
  }

  fragment AppraiserInfoFields on AppraiserInfo {
    ExternalUserId
    UserLicense {
      Name
    }
    CurrentRole {
      Title
      Value
    }
  }

  ${userEventParticipationInfoCalendarViewFragment}
  ${appraiserEventFieldsFragment}
`;

export default GET_ADMIN_CALENDAR;
